"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerPrefix = void 0;
var url_1 = require("../modules/url");
var config = {
    dev: {
        quote_api: '//push2.eastmoney.com/',
        quote_ut: 'fa5fd1943c7b386f172d6893dbfba10b',
        // zixun_api: '//cmsdataapi.eastmoney.com/',
        zixun_api_new: 'https://np-weblist.eastmoney.com/',
        new_zixun_api: "//np-listapi.eastmoney.com/",
        zxg_api: '//myfavor.eastmoney.com/v4/',
        zxg_appkey: 'e9166c7e9cdfad3aa3fd7d93b757e9b1',
        datacenter_api: '//datacenter-web.eastmoney.com/',
        qihuo_api: '//futsseapi.eastmoney.com',
        qihuo_ut: '58b2fa8f54638b60b87d69b31969089c',
        qihuo_api_static: "//futsse-static.eastmoney.com"
    },
    test: {
        quote_api: '//push2test.eastmoney.com/',
        quote_ut: 'fa5fd1943c7b386f172d6893dbfba10b',
        // zixun_api: '//cmsdataapi.eastmoney.com/',
        zixun_api_new: 'https://np-weblist.eastmoney.com/',
        new_zixun_api: "//np-listapi.eastmoney.com/",
        zxg_api: '//myfavor.eastmoney.com/v4/',
        zxg_appkey: 'e9166c7e9cdfad3aa3fd7d93b757e9b1',
        datacenter_api: '//testdatacenter.eastmoney.com/',
        qihuo_api: '//futssetest.eastmoney.com',
        qihuo_ut: '58b2fa8f54638b60b87d69b31969089c',
        qihuo_api_static: "//static.futssetest.eastmoney.com" // test
    },
    prod: {
        quote_api: '//push2.eastmoney.com/',
        quote_ut: 'fa5fd1943c7b386f172d6893dbfba10b',
        // zixun_api: '//cmsdataapi.eastmoney.com/',
        zixun_api_new: 'https://np-weblist.eastmoney.com/',
        new_zixun_api: "//np-listapi.eastmoney.com/",
        zxg_api: '//myfavor.eastmoney.com/v4/',
        zxg_appkey: 'e9166c7e9cdfad3aa3fd7d93b757e9b1',
        datacenter_api: '//datacenter-web.eastmoney.com/',
        qihuo_api: '//futsseapi.eastmoney.com',
        qihuo_ut: '58b2fa8f54638b60b87d69b31969089c',
        qihuo_api_static: "//futsse-static.eastmoney.com"
    },
    getUrl: function (name) {
        if ((0, url_1.getQueryParams)('env') == "dev") {
            return this.dev[name];
        }
        else if ((0, url_1.getQueryParams)('env') == "test") {
            return this.test[name];
        }
        else if ((0, url_1.getQueryParams)('hq-env') == "test") {
            return this.test[name];
        }
        return this.prod[name];
    }
};
exports.default = config;
/** web路由前缀 */
// export let routerPrefix = '/center'
exports.routerPrefix = '/' + window.mainpath;
